module.exports = __webpack_public_path__ + "ENG_NarratorVideo_1-21980c1341ac677884e05a4b23ec1f9a.png";